<template>
  <div class="multiview-thumb-row">
    <thumbnail
      v-for="(image, index) in images"
      :key="index"
      :image="image"
      :index="index"
      :isCirrus="isCirrus"
      :isUserPrefBlackAndWhiteCirrusView="isUserPrefBlackAndWhiteCirrusView"
      :isMultiview="true"
      :exam="exam"
      @click="selectImage(image)"
      @clickCheckbox="toggleImageSelected(image)"></thumbnail>
  </div>
</template>

<script>
import thumbnail from "../misc/Thumbnail";
import { logDetailed } from "../../helpers/utils.js"
export default {
  name: "PatientExamMultiviewImageThumbRow",
  components: {
    thumbnail
  },
  props: {
    exam: Object,
    isSelected: Array
  },
  computed: {
    images() {
      if (this.$store.getters.currentEye != "")
        return this.$store.getters.filteredMultiviewImagesByExSrNo(this.exam.exSrNo);
      return this.$store.getters.multiviewImagesByExSrNo(this.exam.exSrNo);
    },
    isIE() {
      return this.$store.getters.isIE;
    },
    isCirrus() {
      return this.exam.browserType == "Cirrus";
    },
    isUserPrefBlackAndWhiteCirrusView() {
      return this.$store.getters.userPrefBlackAndWhiteCirrusView
    }
  },
  methods: {
    toggleImageSelected(image) {
      this.$store.commit("selectImageMultiview", image);
    },
    selectImage(image) {
      this.$store.dispatch("openBrowserForImage", image);
    }
  },
  mounted() {
    let elapsed = Date.now() - window.beforeLoadMultiview;
    logDetailed("PatientExamMultiviewImageThumbRow", "mounted", "execution-time", elapsed);
  }
};
</script>
